export enum DepositMethodEnum {
  Crypto = 'crypto',
  CryptoApp = 'crypto-app',
  QuickBuy = 'quick-buy',
  BankTransfer = 'bank-transfer',
  InstantDeposit = 'instant-deposit',
}

export type DepositMethod = `${DepositMethodEnum}`;

export interface DepositMethodOption {
  id: DepositMethod;
  title: string;
  description: string;
  icon: React.ReactNode;
  badge?: string;
  badgeVariant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'destructive';
  time?: string;
  fee?: string;
  balance?: string;
}
